module.exports = __webpack_public_path__ + "img/toys.42c40a27.png";